import React from 'react';
import { translate } from 'react-i18next';

import OfflineTooltip from 'components/OfflineTooltip';
import EmployeeActions from 'actions/EmployeeActions';
import SidebarShiftBid from 'components/ScheduleSidebar/SidebarShiftBid.js';
import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import SidebarDropBid from 'components/ScheduleSidebar/SidebarDropBid.js'

class SidebarExchangeBids extends React.Component {
  constructor(props) {
    super(props);

    this.onCancelPost = this.onCancelPost.bind(this);

    this.bidComponents = [];
    this.sortedBidCompents = [];
    this.bidLoadedCount = 0;
    this.bids = [];

    this.state = {
      bidsSorted: false,
    };
  }

  componentDidMount() {
    this.bids = [];
  }

  componentWillUnmount() {
    this.bidComponents = [];
    this.sortedBidCompents = [];
    this.state.bidsSorted = false;
    this.bids = [];
  }

  componentWillReceiveProps() {
    this.bids = [];
    this.state.bidsSorted = false;
    this.resizeSidebar();
  }

  onCancelPost(e) {
    let shift_id = this.props.shiftData.id;
    const exchange = ExchangesStore.getExchangeByShiftId(shift_id);
    let exchange_id = null;
    if (_.isEmpty(exchange)) {
      const validExchange = Utils.getFirstActiveExchange(this.props.shiftData.exchanges);
      if (validExchange != null) {
        exchange_id = validExchange.id;
        shift_id = validExchange.shift_id;
      }
    } else {
      exchange_id = exchange.id;
      shift_id = exchange.shift_id;
    }
    if (exchange_id) {
      EmployeeActions.cancelExchange(exchange_id, shift_id);
    }
  }

  resizeSidebar() {
    setTimeout(() => {
      const panels = document.querySelectorAll('aside .secondarySidebar div.calendar-input');
      let totalHeight = 60;
      [].forEach.call(panels, (el) => {
        totalHeight += parseInt(el.offsetHeight);
      });
      Utils.resizeContainer(totalHeight);
    }, 350);
  }

  _onBidLoaded(shift, comp) {
    this.bidLoadedCount++;
    this.sortedBidCompents.push(comp);
    if (this.bidLoadedCount == this.bidComponents.length) {
      this.bidComponents = [];
      this.sortedBidCompents = _.sortBy(
        this.sortedBidCompents,
        bid => bid.state.shiftDetails.start_time,
      );
      for (let i = 0; i < this.sortedBidCompents.length; i++) {
        this.bidComponents.push(
          <SidebarShiftBid
            parentShiftID={this.props.shiftData.id}
            bidData={this.sortedBidCompents[i].state.bidDetails}
            onBidLoaded={this._onBidLoaded.bind(this)}
            exchangeType={this.props.exchangeType}
            shiftDate={this.props.shiftData.date}
            key={_.uniqueId()}
            onResizeSidebar={this.resizeSidebar.bind(this)}
          />,
        );
      }

      if (!this.state.bidsSorted) {
        this.setState({
          bidsSorted: true,
        });
      }
    }
  }

  render() {
    let startTime = '';
    let endTime = '';
    let shiftDate = '';
    let breaks = null;
    let shift_notes = null;
    let exchange_notes = null;

    if (!this.props.active) {
      return null;
    }

    if (
      this.props.active
      && (!Utils.isNotDefined(this.props.shiftData) && !Utils.isNotDefined(this.props.shiftData))
    ) {
      startTime = moment(this.props.shiftData.start_time)
        .tz(this.props.shiftData.time_zone)
        .format('h:mm a');
      endTime = moment(this.props.shiftData.end_time)
        .tz(this.props.shiftData.time_zone)
        .format('h:mm a');
      const momentObj = moment(this.props.shiftData.start_time)
        .tz(this.props.shiftData.time_zone);
      shiftDate = Utils.formatLocaleDate(momentObj);

      const userName = ExchangesStore.getExchangeUser(this.props.shiftData.user_id);
      var hideEnd = this.props.shiftData.hide_end_time;

      if (
        !Utils.isNotDefined(this.props.shiftData)
        && !Utils.isNotDefined(this.props.shiftData.breaks)
      ) {
        breaks = Utils.formatUnformattedBreaks(this.props.shiftData.breaks);
      }

      if (
        !Utils.isNotDefined(this.props.shiftData)
        && !Utils.isNotDefined(this.props.shiftData.shift_notes)
      ) {
        shift_notes = this.props.shiftData.shift_notes;
      }

      if (
        !Utils.isNotDefined(this.props.shiftData)
        && !Utils.isNotDefined(this.props.shiftData.exchanges)
      ) {
        const shift_id = this.props.shiftData.exchanges[0].shift_id
        const targetExchange = ExchangesStore.getExchangeByShiftId(shift_id);
        if (targetExchange) {
          exchange_notes = targetExchange.notes
        } else {
          exchange_notes = this.props.shiftData.exchanges[0].notes;
        }
      }
    }

    if (!this.state.bidsSorted) {
      if (!Utils.isNotDefined(this.props.shiftData) && this.props.exchangeType == 'my exchange') {
        const exchange = this.props.shiftData;

        const validExchange = Utils.getFirstActiveExchange(exchange.exchanges);
        const drop = !!(
          exchange != null
          && exchange
          && validExchange != null
          && (validExchange.drop || validExchange.drop == 'true')
        );
        this.bids = [];
        if (validExchange != null) {
          this.bids = BidsStore.getBidsByExchangeID(validExchange.id);
        }
        this.bidComponents = [];
        this.sortedBidCompents = [];
        this.bidLoadedCount = 0;

        if (!drop) {
          for (var i = 0; i < this.bids.length; i++) {
            this.bidComponents.push(
              <SidebarShiftBid
                parentShiftID={this.props.shiftData.id}
                bidData={this.bids[i]}
                onBidLoaded={this._onBidLoaded.bind(this)}
                exchangeType={this.props.exchangeType}
                shiftDate={this.props.shiftData.date}
                key={_.uniqueId()}
                onResizeSidebar={this.resizeSidebar.bind(this)}
              />,
            );
          }
        } else {
          for (var i = 0; i < this.bids.length; i++) {
            this.bidComponents.push(
              <SidebarDropBid
                bidData={this.bids[i]}
                exchangeType={this.props.exchangeType}
                shiftDate={this.props.shiftData.date}
                key={_.uniqueId()}
                onResizeSidebar={this.resizeSidebar.bind(this)}
              />,
            );
          }
        }
      } else {
        const exchange = this.props.shiftData
          && this.props.shiftData.shift_details
          && this.props.shiftData.shift_details.id
          ? ExchangesStore.getExchangeByShiftId(this.props.shiftData.shift_details.id)
          : null;
        const drop = !!(exchange != null && exchange && (exchange.drop || exchange.drop == 'true'));
        this.bids = exchange != null && exchange && exchange.id
          ? BidsStore.getBidsByExchangeID(exchange.id)
          : [];
        this.bidComponents = [];
        this.sortedBidCompents = [];
        this.bidLoadedCount = 0;

        if (!drop) {
          for (var i = 0; i < this.bids.length; i++) {
            this.bidComponents.push(
              <SidebarShiftBid
                parentShiftID={this.props.shiftData.id}
                bidData={this.bids[i]}
                onBidLoaded={this._onBidLoaded.bind(this)}
                exchangeType={this.props.exchangeType}
                shiftDate={this.props.shiftData.date}
                key={_.uniqueId()}
                onResizeSidebar={this.resizeSidebar.bind(this)}
              />,
            );
          }
        } else {
          for (var i = 0; i < this.bids.length; i++) {
            this.bidComponents.push(
              <SidebarDropBid
                bidData={this.bids[i]}
                exchangeType={this.props.exchangeType}
                shiftDate={this.props.shiftData.date}
                key={_.uniqueId()}
                onResizeSidebar={this.resizeSidebar.bind(this)}
              />,
            );
          }
        }
      }
    }

    return (
      <div>
        <div
          className={
            !this.props.active
              ? 'hide calendar-input shift-details'
              : 'calendar-input shift-details'
          }
        >
          <span className="calendar-input-bullet scheduled">{this.props.t('SidebarExchangeBids.current_shift')}</span>
          <div className="shift-detail-content">
            <p className="shift-detail-title">
              {this.props.shiftData && this.props.shiftData ? this.props.shiftData.name : ''}
              <br />
              {shiftDate}
              <br />
              {startTime}
              {' – '}
              {!hideEnd ? endTime : this.props.t('SidebarExchangeBids.tbd')}
            </p>

            {!Utils.isNotDefined(breaks) && (
              <p className="shift-detail-breaks">
                {this.props.t('SidebarExchangeBids.breaks')}:&nbsp;
                {breaks}
              </p>
            )}
            <ShiftDetailBlock
              locationID={this.props.shiftData ? this.props.shiftData.location_id : ''}
              departmentID={this.props.shiftData ? this.props.shiftData.department_id : ''}
              position={this.props.shiftData ? this.props.shiftData.position : ''}
              job_site_name={this.props.shiftData ? this.props.shiftData.job_site_name : ''}
              job_site_address={this.props.shiftData ? this.props.shiftData.job_site_address : ''}
            />

            {!Utils.isNotDefined(shift_notes) && (
              <div className="shift-detail-notes-container">
                <p className="shift-detail-title">{this.props.t('SidebarExchangeBids.notes').toUpperCase()}</p>
                <p className="shift-detail-notes">{shift_notes}</p>
              </div>
            )}

            {!Utils.isNotDefined(exchange_notes) && (
              <div className="exchange-shift-detail-notes-container">
                <p className="exchange-shift-detail-title">{this.props.t('SidebarExchangeBids.exchange_notes').toUpperCase()}</p>
                <p className="exchange-shift-detail-notes">{exchange_notes}</p>
              </div>
            )}
          </div>
          <div className="full-flex-container exchange-buttons">
            <OfflineTooltip>
              <button
                className="calendar-input-button cancel-post-button"
                onClick={this.onCancelPost}
                disabled={!Utils.isOnline()}
              >
                {this.props.t('SidebarExchangeBids.cancel_post')}
              </button>
            </OfflineTooltip>
          </div>
        </div>
        {this.bidComponents}
      </div>
    );
  }
}

export default translate()(SidebarExchangeBids);
